"use strict";var e=require("./pdf.worker-87745432.js");("undefined"!=typeof window?window:{}).pdfjsWorker=e.pdf_worker.exports,module.exports={};
